import { render, staticRenderFns } from "./usergroup-jt808-serv-combine-orders.vue?vue&type=template&id=7c0d25d4&scoped=true"
import script from "./usergroup-jt808-serv-combine-orders.vue?vue&type=script&lang=js"
export * from "./usergroup-jt808-serv-combine-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d25d4",
  null
  
)

export default component.exports